import { COLOR_LIGHT_GRAY, COLOR_RED_ALPHA, COLOR_TEXTFIELD_LIGHT, COLOR_WH } from '../colors.constants';

export const colorsUploadImage = {
  colorUploadImageBackground: COLOR_TEXTFIELD_LIGHT,
  colorUploadImageBackgroundSecondary: COLOR_LIGHT_GRAY,
  colorUploadImageBorder: COLOR_WH,
  colorUploadImageError: COLOR_RED_ALPHA,
};
